var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"zoombutton",attrs:{"title":_vm.$t('zoomIn')},on:{"click":function($event){return _vm.zoomIn()}}},[_c('a',{staticClass:"zoomin-icon"})]),_c('div',{staticClass:"zoombutton",attrs:{"title":_vm.$t('zoomOut')},on:{"click":function($event){return _vm.zoomOut()}}},[_c('a',{staticClass:"zoomout-icon"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }